var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenStars = function SvgGreenStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#green-stars_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.134 5.78a.75.75 0 0 0 1.28-.53 1.5 1.5 0 0 1 1.5-1.5.75.75 0 0 0 0-1.5 1.5 1.5 0 0 1-1.5-1.5.75.75 0 0 0-1.5 0 1.5 1.5 0 0 1-1.5 1.5.75.75 0 1 0 0 1.5 1.5 1.5 0 0 1 1.5 1.5c0 .199.08.39.22.53m-7.177 9.927A1 1 0 0 0 6.664 15a4 4 0 0 1 4-4 1 1 0 0 0 0-2 4 4 0 0 1-4-4 1 1 0 1 0-2 0 4 4 0 0 1-4 4 1 1 0 0 0 0 2 4 4 0 0 1 4 4 1 1 0 0 0 .293.707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#green-stars_svg__b)",
    fillOpacity: 0.77,
    d: "M12.134 5.78a.75.75 0 0 0 1.28-.53 1.5 1.5 0 0 1 1.5-1.5.75.75 0 0 0 0-1.5 1.5 1.5 0 0 1-1.5-1.5.75.75 0 0 0-1.5 0 1.5 1.5 0 0 1-1.5 1.5.75.75 0 1 0 0 1.5 1.5 1.5 0 0 1 1.5 1.5c0 .199.08.39.22.53m-7.177 9.927A1 1 0 0 0 6.664 15a4 4 0 0 1 4-4 1 1 0 0 0 0-2 4 4 0 0 1-4-4 1 1 0 1 0-2 0 4 4 0 0 1-4 4 1 1 0 0 0 0 2 4 4 0 0 1 4 4 1 1 0 0 0 .293.707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "green-stars_svg__b",
    x1: -1.721,
    x2: 17.257,
    y1: 8,
    y2: 7.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#A9ED31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#2CEE4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green-stars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgGreenStars;